import { defineField } from '@/form/useForm'
import type { UseAssetFormState, UseAssetFormComputedData } from '../types'
import { EAssetSource, EAttachmentFileType, type IAttachment } from 'findef'
import { AssetImageV2 } from 'components/asset-image-v2'

export const imageField = (props: {
  onRemove?: () => any;
  onUpload?: () => any;
} = {}) => {
  return defineField<UseAssetFormState, any, UseAssetFormComputedData>({
    type: 'file',
    component: 'attachment',
    label: 'Logo',
    tooltip: 'Placeholder tooltip',
    needs: ['asset.source', 'asset.type', 'asset.image', 'userDoesNotWantImage'],
    next: (state) => {
      // Set value to null if the asset is not an image
      // in order to force placeholder component to be rendered
      const value = (state.asset?.image as IAttachment)?.fileType === 'UNKNOWN'
        ? null
        : state.image || (state.asset.image && state.userDoesNotWantImage !== true
            ? state.asset.image
            : state.image);

      return {
        value,
        injectedProps: {
          canUpload: state?.asset?.source !== EAssetSource.IR,
          canDelete: state?.asset?.source !== EAssetSource.IR,
          filetype: EAttachmentFileType.IMAGE,
          onRemove: () => {
            if (props.onRemove) {
              props.onRemove();
            }
          },
          onFileUploaded: () => {
            if (props.onUpload) {
              props.onUpload();
            }
          },
          fileUploadOptions: {
            public: true
          },
          placeholderComponent: () => {
            return <AssetImageV2 investment={state} asset={state?.asset} size="full" variant="gray" />
          }
        }
      }
    }
  })
}
